// Lunar calendar data table: 1900-2100
// 1900-2050: KASI(한국천문연구원) 음양력 API 기반 검증 데이터 (2026-03-24 수집)
// 2051-2100: 미검증 데이터 (추후 검증 필요)
// Format: [encodedMonthInfo, lunarNewYearMonth, lunarNewYearDay]

interface LunarYearInfo {
  leapMonth: number;        // 0 = no leap, 1-12
  leapMonthBig: boolean;    // true if leap month has 30 days
  monthDays: number[];      // days in each month (29 or 30), length 12 or 13 if leap
  lunarNewYearMonth: number; // solar month of lunar new year
  lunarNewYearDay: number;   // solar day of lunar new year
}

// Compressed lunar data for years 1900-2100
// hexdata bits: [3:0]=leapMonth, [16]=leapBig, [15:4]=month1-12 big(1)/small(0)
// Format: [hexdata, lunarNewYearSolarMonth, lunarNewYearSolarDay]

const LUNAR_DATA: readonly [number, number, number][] = [
  // === KASI(한국천문연구원) 검증 데이터: 1900-2050 ===
  [0x04bd8, 1, 31], // 1900
  [0x04ae0, 2, 19], // 1901
  [0x0a570, 2, 8],  // 1902
  [0x054d5, 1, 29], // 1903
  [0x0d260, 2, 16], // 1904
  [0x0d950, 2, 4],  // 1905
  [0x16554, 1, 25], // 1906
  [0x056a0, 2, 13], // 1907
  [0x09ad0, 2, 2],  // 1908
  [0x055d2, 1, 22], // 1909
  [0x04ae0, 2, 10], // 1910
  [0x0a5b6, 1, 30], // 1911
  [0x0a4d0, 2, 18], // 1912
  [0x0d250, 2, 6],  // 1913
  [0x0da95, 1, 26], // 1914
  [0x0b550, 2, 14], // 1915
  [0x056a0, 2, 4],  // 1916
  [0x0ada2, 1, 23], // 1917
  [0x095d0, 2, 11], // 1918
  [0x04bb7, 2, 1],  // 1919
  [0x049b0, 2, 20], // 1920
  [0x0a4b0, 2, 8],  // 1921
  [0x0b4b5, 1, 28], // 1922
  [0x06a90, 2, 16], // 1923
  [0x0ad40, 2, 5],  // 1924
  [0x0bb54, 1, 24], // 1925
  [0x02b60, 2, 13], // 1926
  [0x095b0, 2, 2],  // 1927
  [0x05372, 1, 23], // 1928
  [0x04970, 2, 10], // 1929
  [0x06566, 1, 30], // 1930
  [0x0e4a0, 2, 17], // 1931
  [0x0ea50, 2, 6],  // 1932
  [0x16a95, 1, 26], // 1933
  [0x05b50, 2, 14], // 1934
  [0x02b60, 2, 4],  // 1935
  [0x18ae3, 1, 24], // 1936
  [0x092e0, 2, 11], // 1937
  [0x1c8d7, 1, 31], // 1938
  [0x0c950, 2, 19], // 1939
  [0x0d4a0, 2, 8],  // 1940
  [0x1d8a6, 1, 27], // 1941
  [0x0b690, 2, 15], // 1942
  [0x056d0, 2, 5],  // 1943
  [0x125b4, 1, 26], // 1944
  [0x025d0, 2, 13], // 1945
  [0x092d0, 2, 2],  // 1946
  [0x0d2b2, 1, 22], // 1947
  [0x0a950, 2, 10], // 1948
  [0x0d557, 1, 29], // 1949
  [0x0b4a0, 2, 17], // 1950
  [0x0b550, 2, 6],  // 1951
  [0x15555, 1, 27], // 1952
  [0x04db0, 2, 14], // 1953
  [0x025b0, 2, 4],  // 1954
  [0x18573, 1, 24], // 1955
  [0x052b0, 2, 12], // 1956
  [0x0a9b8, 1, 31], // 1957
  [0x06950, 2, 19], // 1958
  [0x06aa0, 2, 8],  // 1959
  [0x0aea6, 1, 28], // 1960
  [0x0ab50, 2, 15], // 1961
  [0x04b60, 2, 5],  // 1962
  [0x0aae4, 1, 25], // 1963
  [0x0a570, 2, 13], // 1964
  [0x05270, 2, 2],  // 1965
  [0x07263, 1, 22], // 1966
  [0x0d950, 2, 9],  // 1967
  [0x06b57, 1, 30], // 1968
  [0x056a0, 2, 17], // 1969
  [0x09ad0, 2, 6],  // 1970
  [0x04dd5, 1, 27], // 1971
  [0x04ae0, 2, 15], // 1972
  [0x0a4e0, 2, 3],  // 1973
  [0x0d4d4, 1, 23], // 1974
  [0x0d250, 2, 11], // 1975
  [0x0d598, 1, 31], // 1976
  [0x0b540, 2, 18], // 1977
  [0x0d6a0, 2, 7],  // 1978
  [0x195a6, 1, 28], // 1979
  [0x095b0, 2, 16], // 1980
  [0x049b0, 2, 5],  // 1981
  [0x0a9b4, 1, 25], // 1982
  [0x0a4b0, 2, 13], // 1983
  [0x0b27a, 2, 2],  // 1984
  [0x06a50, 2, 20], // 1985
  [0x06d40, 2, 9],  // 1986
  [0x0b756, 1, 29], // 1987
  [0x02b60, 2, 18], // 1988
  [0x095b0, 2, 6],  // 1989
  [0x04b75, 1, 27], // 1990
  [0x04970, 2, 15], // 1991
  [0x064b0, 2, 4],  // 1992
  [0x074a3, 1, 23], // 1993
  [0x0ea50, 2, 10], // 1994
  [0x06d98, 1, 31], // 1995
  [0x05ad0, 2, 19], // 1996
  [0x02b60, 2, 8],  // 1997
  [0x096e5, 1, 28], // 1998
  [0x092e0, 2, 16], // 1999
  [0x0c960, 2, 5],  // 2000
  [0x0e954, 1, 24], // 2001
  [0x0d4a0, 2, 12], // 2002
  [0x0da50, 2, 1],  // 2003
  [0x07552, 1, 22], // 2004
  [0x056c0, 2, 9],  // 2005
  [0x0abb7, 1, 29], // 2006
  [0x025d0, 2, 18], // 2007
  [0x092d0, 2, 7],  // 2008
  [0x0cab5, 1, 26], // 2009
  [0x0a950, 2, 14], // 2010
  [0x0b4a0, 2, 3],  // 2011
  [0x1b4a3, 1, 23], // 2012
  [0x0b550, 2, 10], // 2013
  [0x055d9, 1, 31], // 2014
  [0x04ba0, 2, 19], // 2015
  [0x0a5b0, 2, 8],  // 2016
  [0x05575, 1, 28], // 2017
  [0x052b0, 2, 16], // 2018
  [0x0a950, 2, 5],  // 2019
  [0x0b954, 1, 25], // 2020
  [0x06aa0, 2, 12], // 2021
  [0x0ad50, 2, 1],  // 2022
  [0x06b52, 1, 22], // 2023
  [0x04b60, 2, 10], // 2024
  [0x0a6e6, 1, 29], // 2025
  [0x0a570, 2, 17], // 2026
  [0x05270, 2, 7],  // 2027
  [0x06a65, 1, 27], // 2028
  [0x0d930, 2, 13], // 2029
  [0x05aa0, 2, 3],  // 2030
  [0x0b6a3, 1, 23], // 2031
  [0x096d0, 2, 11], // 2032
  [0x04afb, 1, 31], // 2033
  [0x04ae0, 2, 19], // 2034
  [0x0a4d0, 2, 8],  // 2035
  [0x1d0d6, 1, 28], // 2036
  [0x0d250, 2, 15], // 2037
  [0x0d520, 2, 4],  // 2038
  [0x0dd45, 1, 24], // 2039
  [0x0b6a0, 2, 12], // 2040
  [0x096d0, 2, 1],  // 2041
  [0x055b2, 1, 22], // 2042
  [0x049b0, 2, 10], // 2043
  [0x0a577, 1, 30], // 2044
  [0x0a4b0, 2, 17], // 2045
  [0x0b250, 2, 6],  // 2046
  [0x1b255, 1, 26], // 2047
  [0x06d40, 2, 14], // 2048
  [0x0ada0, 2, 2],  // 2049
  [0x18b63, 1, 23], // 2050
  // === 미검증 데이터: 2051-2100 (KASI 범위 밖) ===
  [0x09570, 2, 11], // 2051
  [0x052f2, 2, 1],  // 2052
  [0x04970, 1, 19], // 2053
  [0x06566, 2, 8],  // 2054
  [0x0d4a0, 1, 28], // 2055
  [0x0ea50, 2, 15], // 2056
  [0x06e95, 2, 4],  // 2057
  [0x05ad0, 1, 24], // 2058
  [0x02b60, 2, 12], // 2059
  [0x186e3, 2, 2],  // 2060
  [0x092e0, 1, 21], // 2061
  [0x1c8d7, 2, 9],  // 2062
  [0x0c950, 1, 29], // 2063
  [0x0d4a0, 2, 17], // 2064
  [0x1d8a6, 2, 5],  // 2065
  [0x0b550, 1, 26], // 2066
  [0x056a0, 2, 14], // 2067
  [0x1a5b4, 2, 3],  // 2068
  [0x025d0, 1, 23], // 2069
  [0x092d0, 2, 11], // 2070
  [0x0d2b2, 1, 31], // 2071
  [0x0a950, 2, 19], // 2072
  [0x0b557, 2, 7],  // 2073
  [0x06ca0, 1, 27], // 2074
  [0x0b550, 2, 15], // 2075
  [0x15355, 2, 5],  // 2076
  [0x04da0, 1, 24], // 2077
  [0x0a5b0, 2, 12], // 2078
  [0x14573, 2, 2],  // 2079
  [0x052b0, 1, 22], // 2080
  [0x0a9a8, 2, 9],  // 2081
  [0x0e950, 1, 29], // 2082
  [0x06aa0, 2, 17], // 2083
  [0x0aea6, 2, 6],  // 2084
  [0x0ab50, 1, 26], // 2085
  [0x04b60, 2, 14], // 2086
  [0x0aae4, 2, 3],  // 2087
  [0x0a570, 1, 24], // 2088
  [0x05260, 2, 10], // 2089
  [0x0f263, 1, 30], // 2090
  [0x0d950, 2, 18], // 2091
  [0x05b57, 2, 7],  // 2092
  [0x056a0, 1, 27], // 2093
  [0x096d0, 2, 15], // 2094
  [0x04dd5, 2, 5],  // 2095
  [0x04ad0, 1, 25], // 2096
  [0x0a4d0, 2, 12], // 2097
  [0x0d4d4, 2, 1],  // 2098
  [0x0d250, 1, 21], // 2099
  [0x1d520, 2, 9],  // 2100
];

const BASE_YEAR = 1900;

/**
 * Helper: get days in a Gregorian month (inlined to avoid circular imports).
 */
function solarDaysInMonth(year: number, month: number): number {
  const isLeap = (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
  const days = [31, isLeap ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  return days[month - 1];
}

/**
 * Decode lunar year info from compressed data.
 *
 * 데이터 비트 레이아웃 (표준 음력 데이터 형식):
 *   [3:0]  = 윤월 번호 (0이면 윤달 없음, 1~12)
 *   [16]   = 윤달 대월 여부 (1 = 30일, 0 = 29일)
 *   [15:4] = 1~12월 대소 (bit15 = 1월, bit4 = 12월, 1 = 30일, 0 = 29일)
 */
function decodeLunarYear(data: number): { leapMonth: number; leapMonthBig: boolean; monthSizes: boolean[] } {
  const leapMonth = data & 0xF;
  const leapMonthBig = !!((data >> 16) & 0x1);
  const monthSizes: boolean[] = [];
  for (let i = 15; i >= 4; i--) {
    monthSizes.push(!!((data >> i) & 0x1)); // true = big (30), false = small (29)
  }
  return { leapMonth, leapMonthBig, monthSizes };
}

/**
 * Get detailed info for a lunar year.
 */
function getLunarYearInfo(lunarYear: number): LunarYearInfo {
  const idx = lunarYear - BASE_YEAR;
  if (idx < 0 || idx >= LUNAR_DATA.length) {
    throw new Error(`Lunar year ${lunarYear} is out of supported range (${BASE_YEAR}-${BASE_YEAR + LUNAR_DATA.length - 1})`);
  }

  const [data, lnyMonth, lnyDay] = LUNAR_DATA[idx];
  const { leapMonth, leapMonthBig, monthSizes } = decodeLunarYear(data);

  const monthDays: number[] = [];
  for (let m = 0; m < 12; m++) {
    monthDays.push(monthSizes[m] ? 30 : 29);
    if (leapMonth === m + 1) {
      // Insert leap month after regular month
      monthDays.push(leapMonthBig ? 30 : 29);
    }
  }

  return {
    leapMonth,
    leapMonthBig,
    monthDays,
    lunarNewYearMonth: lnyMonth,
    lunarNewYearDay: lnyDay,
  };
}

/**
 * Convert lunar date to solar date.
 *
 * @param lunarYear - Lunar year
 * @param lunarMonth - Lunar month (1-12)
 * @param lunarDay - Lunar day
 * @param isLeapMonth - Whether this is a leap month
 * @returns Solar date { year, month, day }
 */
export function lunarToSolar(
  lunarYear: number,
  lunarMonth: number,
  lunarDay: number,
  isLeapMonth: boolean = false
): { year: number; month: number; day: number } {
  const info = getLunarYearInfo(lunarYear);

  // Calculate days from lunar new year to the target date
  let dayOffset = 0;
  let monthIndex = 0;

  for (let m = 1; m <= 12; m++) {
    if (m === lunarMonth && !isLeapMonth) {
      break;
    }
    dayOffset += info.monthDays[monthIndex];
    monthIndex++;

    // If this month has a leap month and we haven't reached it yet
    if (info.leapMonth === m && m < lunarMonth) {
      dayOffset += info.monthDays[monthIndex];
      monthIndex++;
    } else if (info.leapMonth === m && m === lunarMonth && isLeapMonth) {
      // We want the leap month itself
      break;
    }
  }

  dayOffset += lunarDay - 1;

  // Solar date of lunar new year
  let solarYear = lunarYear;
  let solarMonth = info.lunarNewYearMonth;
  let solarDay = info.lunarNewYearDay;

  // Add offset days to the lunar new year solar date
  solarDay += dayOffset;

  while (solarDay > solarDaysInMonth(solarYear, solarMonth)) {
    solarDay -= solarDaysInMonth(solarYear, solarMonth);
    solarMonth++;
    if (solarMonth > 12) {
      solarMonth = 1;
      solarYear++;
    }
  }

  return { year: solarYear, month: solarMonth, day: solarDay };
}

/**
 * Convert solar date to lunar date.
 *
 * @param solarYear - Solar year
 * @param solarMonth - Solar month (1-12)
 * @param solarDay - Solar day
 * @returns Lunar date { year, month, day, isLeapMonth }
 */
export function solarToLunar(
  solarYear: number,
  solarMonth: number,
  solarDay: number
): { year: number; month: number; day: number; isLeapMonth: boolean } {
  // Find the lunar year whose lunar new year is closest to (but before) the solar date
  let lunarYear = solarYear;
  let info = getLunarYearInfo(lunarYear);

  // Check if the solar date is before this year's lunar new year
  const lnySolarMonth = info.lunarNewYearMonth;
  const lnySolarDay = info.lunarNewYearDay;

  if (solarMonth < lnySolarMonth || (solarMonth === lnySolarMonth && solarDay < lnySolarDay)) {
    lunarYear--;
    info = getLunarYearInfo(lunarYear);
  }

  // Calculate days from lunar new year to the solar date
  // Days from lunar new year (solar date) to target solar date
  const lnyM = info.lunarNewYearMonth;
  const lnyD = info.lunarNewYearDay;

  // Compute total days difference
  let totalDays = 0;
  // If they're in the same year
  if (lunarYear === solarYear) {
    // Simple case
    let m = lnyM;
    let d = lnyD;
    while (m < solarMonth || (m === solarMonth && d < solarDay)) {
      if (m === solarMonth) {
        totalDays += solarDay - d;
        break;
      }
      totalDays += solarDaysInMonth(solarYear, m) - d + 1;
      d = 1;
      m++;
      if (m === solarMonth) {
        totalDays += solarDay - 1;
        break;
      }
    }
    if (solarMonth === lnyM && solarDay === lnyD) {
      totalDays = 0;
    }
  } else {
    // Cross-year: count remaining days in lunarYear (the year of LNY)
    totalDays = solarDaysInMonth(lunarYear, lnyM) - lnyD + 1;
    for (let m = lnyM + 1; m <= 12; m++) {
      totalDays += solarDaysInMonth(lunarYear, m);
    }
    // Plus days in solarYear
    for (let m = 1; m < solarMonth; m++) {
      totalDays += solarDaysInMonth(solarYear, m);
    }
    totalDays += solarDay - 1;
  }

  // Now convert totalDays offset to lunar month/day
  let remaining = totalDays;
  let lunarMonth = 0;
  let isLeapMonth = false;
  let monthIndex = 0;

  for (let m = 1; m <= 12; m++) {
    const days = info.monthDays[monthIndex];
    if (remaining < days) {
      lunarMonth = m;
      isLeapMonth = false;
      break;
    }
    remaining -= days;
    monthIndex++;

    // Check leap month
    if (info.leapMonth === m) {
      const leapDays = info.monthDays[monthIndex];
      if (remaining < leapDays) {
        lunarMonth = m;
        isLeapMonth = true;
        break;
      }
      remaining -= leapDays;
      monthIndex++;
    }
  }

  return {
    year: lunarYear,
    month: lunarMonth,
    day: remaining + 1,
    isLeapMonth,
  };
}
